import React from 'react';

const SchedulingContext = React.createContext('scheduling');

export const SchedulingContextProvider = SchedulingContext.Provider;

export default SchedulingContext;
